export default __webpack_public_path__ + "images/transparent.082acd.png";